export const convertToBase64 = {
  async execute(file: File): Promise<string> {
    return URL.createObjectURL(file);
  },
};
